import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http, formatError } from "@/lib/api";
import { STEP_KEY, setVerified } from "@/lib/staff";

// Google sends staff back here after the "sign in again" step of confirming it's them.
export default function StaffVerifyReturn() {
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    let step = null;
    try { step = JSON.parse(sessionStorage.getItem(STEP_KEY) || "null"); } catch { step = null; }
    sessionStorage.removeItem(STEP_KEY);
    window.history.replaceState(null, "", "/staff/verify");
    const back = step?.back?.startsWith("/staff") ? step.back : "/staff";
    if (!sid || !step?.token) {
      toast.error("That confirmation didn't finish. Please start again.");
      navigate(back, { replace: true });
      return;
    }
    http.post("/staff/verify/finish", { step_token: step.token, session_id: sid })
      .then(({ data }) => { setVerified(data.verified_token, data.expires_in); toast.success("Confirmed. You can make your change now."); })
      .catch((e) => toast.error(formatError(e)))
      .finally(() => navigate(back, { replace: true }));
  }, [navigate]);
  return (
    <div className="min-h-[100dvh] bg-[#0A0F1C] flex items-center justify-center text-sm text-neutral-400" data-testid="staff-verify-return">Confirming it's you…</div>
  );
}
